var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLocationRed(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.99992 0C4.80068 0 2.21729 2.5834 2.21729 5.78263C2.21729 6.8981 2.57362 7.96322 3.06938 8.83852L6.83797 15.3609C7.07423 15.7869 7.55063 16 7.99992 16C8.44924 16 8.90236 15.7869 9.16187 15.3609L12.9305 8.84239C13.4301 7.96702 13.7826 6.92127 13.7826 5.78643C13.7826 2.58727 11.1992 0 7.99992 0ZM7.99992 7.4907C6.83797 7.4907 5.88904 6.54177 5.88904 5.37982C5.88904 4.21788 6.83797 3.26895 7.99992 3.26895C9.16187 3.26895 10.1108 4.21788 10.1108 5.37982C10.1108 6.54565 9.16187 7.4907 7.99992 7.4907Z",
    fill: "red"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocationRed);
export default __webpack_public_path__ + "static/media/location_red.b5210cefcc87ff8d9438c026fe7d6e06.svg";
export { ForwardRef as ReactComponent };